module.exports = __webpack_public_path__ + "cf.svg?d8dd15d37e5023c354126187fe19327f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/cf.svg
// module id = 1035
// module chunks = 0